import React, { FC } from 'react'

import SvgStar from '@Assets/SVG/Star'
import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

import styles from './PopularGiftChip.module.scss'

export interface PopularChipProps extends ChipProps{
}

export const PopularGiftChip: FC<PopularChipProps> = () => {
  const { t } = useTranslation()

  return (
    <Chip className={styles.popularGiftChip} color="blue" size="small">
      <SvgStar />
      {t('common:POPULAR_GIFT_TAG', 'Popular gift')}
    </Chip>
  )
}
